export const TABLE_CELL_LINE_CLASS = 'qlrte__better-table-cell-line'
export const ROW_TOOL_CLASS = 'qlrte__row-tool'
export const ROW_TOOL_CELL_CLASS = 'qlrte__row-tool-cell'
export const ROW_TOOL_CELL_HOLDER_CLASS = 'qlrte__row-tool-cell-holder'
export const COL_TOOL_CLASS = 'qlrte__col-tool'
export const COL_TOOL_CELL_CLASS = 'qlrte__col-tool-cell'
export const COL_TOOL_CELL_HOLDER_CLASS = 'qlrte__col-tool-cell-holder'
export const SELECT_LINE_CLASS = 'qlrte__selection-line'
export const OPERATE_MENU_CLASS = 'qlrte__op-menu'
export const OPERATE_MENU_ITEM_CLASS = 'qlrte__op-menu-item'
export const OPERATE_MENU_ICON_CLASS = 'qlrte__op-menu-icon'
export const OPERATE_MENU_ICON_PREFIX_CLASS = 'qlrte__op-menu-icon-prefix'
export const OPERATE_MENU_TEXT_CLASS = 'qlrte__op-menu-text'
export const OPERATE_MENU_DIVIDING_CLASS = 'qlrte__op-menu-dividing'
export const OPERATE_MENU_SUBTITLE_CLASS = 'qlrte__op-menu-subtitle'
export const OPERATE_MENU_COLORPICKER_CLASS = 'qlrte__op-menu-color-picker'
export const OPERATE_MENU_COLORPICKER_ITEM_CLASS
  = 'qlrte__op-menu-color-picker-item'
export const COL_ATTRIBUTES = ['width']
export const COL_DEFAULT = {
  width: 100,
}
export const CELL_IDENTITY_KEYS = ['row', 'cell']
export const CELL_ATTRIBUTES = ['rowspan', 'colspan', 'cell-bg', 'list']
export const CELL_DEFAULT = {
  rowspan: 1,
  colspan: 1,
}
export const ERROR_LIMIT = 5

export const SCROLL_BAR_PANEL_HEIGHT = 32
export const ROW_TOOL_WIDTH = 16
export const COL_TOOL_HEIGHT = 16
export const CELL_MIN_WIDTH = 50
export const CELL_MIN_HEIGHT = 29
export const PRIMARY_COLOR = ['#5170ff', 'var(--brand-1, #5170ff)']

export const MENU_ITEM_HEIGHT = 40
export const MENU_MIN_HEIGHT = 150
export const MENU_WIDTH = 205

export const LINE_POSITIONS = ['left', 'right', 'top', 'bottom']
